import { render, staticRenderFns } from "./verifyPhoneAndEmail.vue?vue&type=template&id=7b13574c&scoped=true"
import script from "./verifyPhoneAndEmail.vue?vue&type=script&lang=js"
export * from "./verifyPhoneAndEmail.vue?vue&type=script&lang=js"
import style0 from "./verifyPhoneAndEmail.vue?vue&type=style&index=0&id=7b13574c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b13574c",
  null
  
)

export default component.exports